// @ts-strict-ignore
import { faPrescriptionBottle } from "@fortawesome/pro-regular-svg-icons";
import { Fragment } from "react";

import { Spacer, Tooltip, Typography } from "@aviary";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { useFlippers } from "@shared/hooks/useFlippers/useFlippers";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";

import * as styles from "./Ingredient.styles";

interface Props {
  name: string;
  unit?: string;
  amount?: number;
  alternateUnit?: string;
  alternateAmount?: number;
  productNames: string[];
  withIndent?: boolean;
  showProductIcon?: boolean;
  productCount?: number;
  isForAccordion?: boolean;
  isForAccordionChild?: boolean;
}

const Ingredient = ({
  name,
  unit,
  amount,
  alternateUnit,
  alternateAmount,
  productNames,
  withIndent,
  showProductIcon,
  productCount,
  isForAccordion,
  isForAccordionChild,
}: Props) => {
  const { phoneLarge } = useBreakpoints();
  const isPhone = phoneLarge.lessThan;
  const [isGummiesMedicationEnabled] = useFlippers("aura_medication_ingredient_intake");

  const renderTooltipContent = (
    <>
      {productNames?.map(productName => (
        <Fragment key={productName}>
          {productName}
          <br />
        </Fragment>
      ))}
    </>
  );

  // if amount is more than or equal to 10,000, add commas to it
  const formatAmount = (numberAmount: number) => {
    if (numberAmount < 10000) {
      return numberAmount.toString();
    }

    return numberAmount.toLocaleString();
  };

  const getAmountAndUnit = () => {
    if (alternateAmount > 0 && alternateUnit && amount > 0 && unit) {
      return `${formatAmount(alternateAmount)} ${alternateUnit} (${formatAmount(amount)} ${unit})`;
    } else if (amount > 0 && unit) {
      return `${formatAmount(amount)} ${unit}`;
    } else {
      return "-";
    }
  };

  return (
    <div css={[styles.ingredient, withIndent && styles.withIndent]}>
      <Typography isMarginless css={[styles.name, !isGummiesMedicationEnabled && styles.oldName]}>
        {name}
      </Typography>
      {!!showProductIcon && (
        <Tooltip
          tooltipContent={renderTooltipContent}
          css={[styles.button, !isGummiesMedicationEnabled && styles.oldButton]}
        >
          {!isPhone && (
            <div
              css={[
                isForAccordion && !withIndent && showProductIcon && styles.productIcon,
                isForAccordionChild && !withIndent && showProductIcon && styles.iconForChild,
              ]}
            >
              <FontAwesomeIcon icon={faPrescriptionBottle} />
              <Spacer width="half" />
              {productCount}
            </div>
          )}
        </Tooltip>
      )}
      <Typography
        isMarginless
        css={[styles.amount, !isGummiesMedicationEnabled && styles.oldAmount]}
      >
        <span css={styles.amountContent} title={getAmountAndUnit()}>
          {getAmountAndUnit()}
        </span>
      </Typography>
    </div>
  );
};

export { Ingredient };
